import { gql } from '@apollo/client'

export default gql(`
    mutation($name: String! $key: String! $project: String $metaFields: [CreateFieldInput] ) {
        createContentPlaceHolder(
            input: {
                name: $name
                key: $key
                metaFields: $metaFields
            }
            project: $project
        ) {
            id
            name
            key
            usedCount
            metaFields{
                id
                tooltip
                displayName
                displayTitle
                type
                isRequired
                values
            }
        }
    }`
)
